import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Import from project
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import MemberForm from "./Form/MemberForm";
import DialogDelete from "../../Utils/DialogDelete";
import { useDeleteMember } from "./Delete/useDeleteMember";

export default function MemberAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const { handleDelete, loading } = useDeleteMember({
    handleClose: handleCloseDel,
    setRefetch,
  });
  const handleDeleteData = () => {
    handleDelete(editData?._id);
  };
  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {/* {hasPermission(userLogin?.user?.role, "update:user") && ( */}
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        {/* )} */}

        {/* {hasPermission(userLogin?.user?.role, "delete:user") && ( */}
        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        {/* )} */}
      </Stack> 

      {openEdit && (
        <MemberForm
          open={openEdit}
          handleClose={handleCloseEdit}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle="Update"
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_member")}
          handleDelete={handleDeleteData}
          editData={editData}
        />
      )}
    </div>
  );
}
